import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  payments: [],
  isLoading: true,
  isViewModalOpen: false,
  isDeleteModalOpen: false,
  viewSinglePayment: {},
};

export const fetchPayments = createAsyncThunk("payment/fetchPayments", () => {
  return axios
    .get("https://62de2ff379b9f8c30ab47809.mockapi.io/payments")
    .then((response) => response.data);
});

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    viewPayment: (state, action) => {
      state.isViewModalOpen = true;
      state.viewSinglePayment = action.payload;
    },
    openDeleteModal: (state, action) => {
      state.isDeleteModalOpen = true;
      state.viewSinglePayment = action.payload;
    },
    closeModal: (state) => {
      state.isViewModalOpen = false;
      state.isDeleteModalOpen = false;
      state.viewSinglePayment = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPayments.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPayments.fulfilled, (state, action) => {
      state.isLoading = false;
      state.payments = action.payload;
      state.error = "";
    });
    builder.addCase(fetchPayments.rejected, (state, action) => {
      state.isLoading = false;
      state.payments = [];
      state.error = action.error.message;
    });
  },
});

export const { viewPayment, openDeleteModal, closeModal } =
  paymentSlice.actions;
export default paymentSlice.reducer;
